import React, { useContext, useRef, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import {
  Content,
  CardLatestDeliveries,
  ContainerDataDelivery,
  ContainerDatas,
  ContainerDescription,
  ContentAvatar,
  ContentDataItems,
  DataUser,
  DescriptionDataItem,
  IconContainer,
  IconContainerAction,
  IconFA5,
  IconFE,
  StatusDelivery,
  TextDataItem,
  TextDeliveries,
  TitleCard,
  TitleDataUser,
  TitleDelivery,
} from "./styles";
import { BottomSheet, Button, CardDelivery, Container, Header } from "../../../components";
import { themes } from "../../../design/colors";
import ClientContext from "../../../context/client";
import RouteContext from "../../../context/route";
import CardRoutes from "../../../components/CardRoutes";
import { Modalize } from "react-native-modalize";

function RouteAdmin() {
  const navigation = useNavigation();
  const bottomSheetErrorRef = useRef<Modalize>(null);
  const { newRoute, allOrders, cancelRoute, loading } = useContext(RouteContext);

  const [destinyName, setDestinyName] = useState('');
  const [idRoute, setIdRoute] = useState(0);

  function handleAddRoute() {
    navigation.navigate("SelectDriverAdmin");
  }

  function handleOpenConfirmDelete(id: number, destinyName: string) {
    setDestinyName(destinyName);
    setIdRoute(id);
    bottomSheetErrorRef.current?.open();
  }

  async function handleConfirmDelete() {
    const data = { order_status: 3 };
    await cancelRoute(idRoute, data);
    bottomSheetErrorRef.current?.close();
  }

  return (
    <Container>
      <Header name="Bruno Morais" />
      <Content>
        <TextDeliveries>Entregas cadastradas</TextDeliveries>
        <Button title="Adicionar nova rota" icon="plus" onPress={handleAddRoute} />
        {allOrders.map((item: any, index: number) => (
          <CardRoutes
            first={index === 0 && true}
            title={item.destiny_name}
            subtitle={item.status_name}
            icon="route"
            iconAction="trash-2"
            onPress={() => handleOpenConfirmDelete(item.id, item.destiny_name)}
          />
        ))}
      </Content>
      <BottomSheet
          bottomSheetRef={bottomSheetErrorRef}
          title="Apagar rota"
          description={`Tem certeza que deseja apagar a rota ${destinyName}?`}
          textButton="Apagar"
          typeButton="error"
          accessibilityHintButton="Apagar"
          loading={loading}
          onClose={() => bottomSheetErrorRef.current?.close()}
          onPress={handleConfirmDelete}
        />
    </Container>
  );
}

export default RouteAdmin;
